import {
  Grid as ChakraGrid,
  GridProps,
  GridItem as ChakraGridItem,
  GridItemProps,
  forwardRef,
} from '@chakra-ui/react';

/**
 * Grid is a layout for managing grid layouts
 */
export const Grid = forwardRef((props: GridProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraGrid ref={ref} {...otherProps}>
      {children}
    </ChakraGrid>
  );
});

export const GridItem = forwardRef((props: GridItemProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraGridItem ref={ref} {...otherProps}>
      {children}
    </ChakraGridItem>
  );
});
